// Copyright (c) Docugami, Inc. All rights reserved.

import { LogLevel } from "@microsoft/signalr";
import { Logger, LoggerCategory } from "utils/Logger";

export class SignalRLogger implements signalR.ILogger {
    log(logLevel: LogLevel, message: string): void {
        switch (logLevel) {
            case LogLevel.Debug:
                Logger.LogDebug(LoggerCategory.SignalR, message);
                break;

            case LogLevel.Information:
                Logger.LogInformation(LoggerCategory.SignalR, message);
                break;

            case LogLevel.Warning:
                Logger.LogWarning(LoggerCategory.SignalR, message);
                break;

            case LogLevel.Error:
                Logger.LogError(LoggerCategory.SignalR, message);
                break;

            case LogLevel.Critical:
                Logger.LogCritical(LoggerCategory.SignalR, message);
                break;


            case LogLevel.None:
            case LogLevel.Trace:
            default:
                Logger.LogTrace(LoggerCategory.SignalR, message);
                break;
        }
    }
}
